import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  MockedConnectivityRanking,
  MockedDeviceAvailableProperties,
  MockedTrendingData,
} from './analytics-mocks';
import {
  AnalyticsApiModel,
  ConnectivityRanking,
  DataTrendingRequestBody,
  GenericDataResponse,
  PropertySincePayload,
  PropertySinceResponse,
  RawTrendingData,
} from './analytics.model';

@Injectable({ providedIn: 'root' })
export class AnalyticsMockApi implements AnalyticsApiModel {
  constructor() {}

  //TODO - change rest of endpoints to a new demo approach

  getDeviceAvailableProperties(
    body: PropertySincePayload
  ): Observable<GenericDataResponse<PropertySinceResponse>> {
    return of(new MockedDeviceAvailableProperties().mock(body));
  }

  getConnectivityRanking(_companyId: string): Observable<GenericDataResponse<ConnectivityRanking>> {
    return of(new MockedConnectivityRanking().mock());
  }

  getTrendingData(body: DataTrendingRequestBody): Observable<{ data: RawTrendingData[] }> {
    return of(new MockedTrendingData().mock(body));
  }
}
